/*
 * The add-in's function file.
 *
 * The manifest's <FunctionFile> element is required by the VersionOverrides
 * v1.1 schema even when, as here, every ribbon control opens the task pane
 * rather than executing a function. So this file exists, initialises Office,
 * and does nothing else.
 *
 * Do not reintroduce the scaffold's sample `action` handler: it calls
 * notificationMessages.replaceAsync, which needs ReadWriteItem. This add-in
 * asks for ReadItem only, and widening that forces every customer's admin to
 * re-consent.
 */

/* global Office */

Office.onReady(() => {
  // Nothing to register: there are no ExecuteFunction commands.
});
